<template>
    <div>
        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- Search parameters -->
        <div class="card card-custom gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">Search parameters</h3>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <b-form inline class="col">
                        <label class="mr-sm-2 col-xl-2" for="inline-form-custom-select-pref">Search parameters</label>
                        <b-form-select v-model="parameters.month" :options="options.month"
                            class="col-xl-2"></b-form-select>
                        <b-form-select v-model="parameters.year" :options="options.year"
                            class="col-xl-2"></b-form-select>

                        <b-button variant="success" class="col-xl-2 ml-5" :disabled="isLoading"
                            @click="loadPayments()">Search</b-button>
                    </b-form>
                </div>
            </div>
        </div>

        <!-- Preloader -->
        <PagePreloader v-if="isLoading"></PagePreloader>

        <template v-if="!isLoading">
            <div class="card card-custom">
                <div class="card-body">
                    <h1>{{ Math.round(total * 100) / 100 }}€ for this month</h1>
                    <template v-if="payments.length">
                        <b-col lg="6" class="my-1">
                            <b-form-group label="Filter" label-for="filter-input" label-cols-sm="3"
                                label-align-sm="right" label-size="sm">
                                <b-input-group size="sm">
                                    <b-form-input id="filter-input" v-model="table.filter" type="search"
                                        placeholder="Type to Search"></b-form-input>

                                    <b-input-group-append>
                                        <b-button :disabled="!table.filter" @click="table.filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-pagination v-model="table.currentPage" :total-rows="table.totalRows"
                            :per-page="table.perPage" align="fill"></b-pagination>
                        <b-table striped bordererd table-variant="secondary" hover :items="payments"
                            :fields="table.fields" :current-page="table.currentPage" :per-page="table.perPage"
                            :filter="table.filter" :filter-included-fields="table.filterOn" @filtered="onFiltered"
                            :sort-by.sync="table.sortBy" :sort-desc.sync="table.sortDesc">
                            <template #cell(identifier)="data">
                                <template v-if="data.item.origin == 'PayPal'">
                                    {{ data.item.payerEmail }} - {{ data.item.payerFullName }}
                                </template>
                                <template v-if="data.item.origin == 'Stripe'">
                                    {{ data.item.paymentId }}
                                </template>
                            </template>

                            <!-- :filter="filter"
                            :filter-included-fields="filterOn"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            stacked="md"
                            show-empty
                            small
                            @filtered="onFiltered" -->

                            <!-- <template #cell(name)="row">
                                {{ row.value.first }} {{ row.value.last }}
                            </template>

                            <template #cell(actions)="row">
                                <b-button
                                    size="sm"
                                    @click="info(row.item, row.index, $event.target)"
                                    class="mr-1"
                                >
                                    Info modal
                                </b-button>
                                <b-button size="sm" @click="row.toggleDetails">
                                    {{ row.detailsShowing ? "Hide" : "Show" }} Details
                                </b-button>
                            </template>

                            <template #row-details="row">
                                <b-card>
                                    <ul>
                                        <li v-for="(value, key) in row.item" :key="key">
                                            {{ key }}: {{ value }}
                                        </li>
                                    </ul>
                                </b-card>
                            </template> -->
                        </b-table>
                    </template>
                    <template v-else> No payments to display </template>
                </div>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style scoped></style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";

// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "BlankPage",
    mixins: [axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
    },
    data() {
        return {
            // Init
            errors: [],
            isLoading: true,
            parameters: {
                month: null,
                year: null,
            },

            // Data
            parameters: {},
            payments: [],
            total: 0,

            // Options
            options: {
                month: [
                    { value: 1, text: "01 - January" },
                    { value: 2, text: "02 - February" },
                    { value: 3, text: "03 - March" },
                    { value: 4, text: "04 - April" },
                    { value: 5, text: "05 - May" },
                    { value: 6, text: "06 - June" },
                    { value: 7, text: "07 - July" },
                    { value: 8, text: "08 - August" },
                    { value: 9, text: "09 - September" },
                    { value: 10, text: "10 - October" },
                    { value: 11, text: "11 - November" },
                    { value: 12, text: "12 - December" },
                ],
                // year: [
                //     { value: 2019, text: "2019" },
                //     { value: 2020, text: "2020" },
                //     { value: 2021, text: "2021" },
                //     { value: 2022, text: "2022" },
                //     { value: 2023, text: "2023" },
                //     { value: 2024, text: "2024" },
                //     { value: 2025, text: "2025" },
                //     { value: 2026, text: "2026" },
                //     { value: 2027, text: "2027" },
                //     { value: 2028, text: "2028" },
                //     { value: 2029, text: "2029" },
                // ],
                year: Array.from({ length: 20 }, (_, i) => {
                    const value = 2019 + i;
                    return { value, text: value.toString() };
                }),
            },

            // Table
            table: {
                fields: [
                    { key: "origin", label: "Origin", sortable: true, sortDirection: "desc" },
                    {
                        key: "datetime",
                        label: "Date",
                        sortable: true,
                        sortDirection: "desc",
                        formatter: (value) => {
                            let d = new Date(value);
                            return d.toDateString();
                        },
                    },
                    { key: "identifier", label: "Identifier" },
                    {
                        key: "payerCountry",
                        label: "Country",
                        sortable: true,
                        sortDirection: "desc",
                    },
                    {
                        key: "value",
                        label: "Amount",
                        sortable: true,
                        sortDirection: "desc",
                        formatter: (value) => {
                            return value + " €";
                        },
                    },
                    {
                        key: "tax",
                        label: "VAT",
                        sortable: true,
                        sortDirection: "desc",
                        formatter: (value) => {
                            return value + " €";
                        },
                    },
                    {
                        key: "gross",
                        label: "Gross?",
                        sortable: true,
                        sortDirection: "desc",
                        formatter: (value) => {
                            return value + " €";
                        },
                    },
                    // { key: 'identifier', label: 'Identifier', }
                ],
                perPage: 15,
                currentPage: 1,
                totalRows: 0,
                filter: "",
                filterOn: [], // Can be used to set unique columns we want to filter on
                sortBy: "datetime",
                sortDesc: true,
            },
        };
    },

    methods: {
        // Set default year and month
        setDateDefaults() {
            const d = new Date();
            this.parameters.month = d.getMonth() + 1;
            this.parameters.year = d.getFullYear();
        },
        // First method here
        checkAdmin() {
            if (!this.isAdmin) {
                this.$router.push({
                    name: "dashboard",
                    params: {
                        propFlashMessages: [
                            {
                                type: "danger",
                                message: "You aren't authorized to access this area.",
                            },
                        ],
                    },
                });
            }
        },

        // Get payments
        loadPayments() {
            // Set
            this.isLoading = true;
            this.total = 0;

            // Reset
            this.table.currentPage = 1;
            this.table.sortBy = "datetime";
            this.table.sortDesc = true;

            // Perform axios
            axios
                .post("admin/getpayments", {
                    month: this.parameters.month,
                    year: this.parameters.year,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Add data
                    this.payments = data.data;

                    // Check
                    if (this.payments.length) {
                        this.payments.forEach(currentItem => {
                            this.total += currentItem.value
                        });
                    }

                    // Set count
                    this.table.totalRows = this.payments.length;

                    // Check status
                    // if (data.status == "OK") {
                    //     // Set the data
                    //     this.current_exam = data.data;
                    // } else {
                    //     this.currentSection = "main";
                    // }

                    // Check length of messages
                    if (data.messages.length > 0) {
                        data.messages.forEach((message) => {
                            this.errors.push({
                                type: message.type,
                                message: message.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close off preloader
                    this.isLoading = false;
                });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.table.totalRows = filteredItems.length;
            this.table.currentPage = 1;
        },
    },

    mounted() {
        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Admin Payments", route: "admin-payments" },
        ]);

        // Check if we're admin
        this.checkAdmin();

        // Set defaults
        this.setDateDefaults();

        // Get payments
        this.loadPayments();
    },

    computed: {
        ...mapGetters({ currentUser: "auth/currentUser", isAdmin: "auth/isAdmin" }),
        // ...mapGetters({
        //     // currentUser: "auth/currentUser",
        //     // isPremium: "auth/isPremium",
        //     // isEnterprise: "auth/isEnterprise",
        // }),
    },
};
</script>
